import React from 'react';
import MaskedIcon from '~/App/Components/MaskedIcon';
import { assetUrl } from '~/helpers';

const FilmIcon = () => (
  <MaskedIcon
    className='w-5 h-4'
    iconUrl={assetUrl('assets/images/my-library/film.svg')}
  />
);

export default FilmIcon;
